import axios from 'axios';

import {
    requestInterceptor,
    requestErrorHandler,
    responseInterceptor,
    responseErrorHandler,
} from '@hh.ru/autotest-utils';
import { urlParser } from '@hh.ru/browser-api-utils';

import defaultHeaderInterceptor from './defaultHeaderInterceptor';
import hhtmInterceptor from './hhtmInterceptor';
import xsrfInterceptor from './xsrfInterceptor';

const instance = axios.create();

instance.defaults.headers.common.Accept = 'application/json';
instance.defaults.headers.common['Content-Type'] = 'application/json';
instance.defaults.paramsSerializer = urlParser.stringify;

instance.interceptors.request.use(xsrfInterceptor);
instance.interceptors.request.use(hhtmInterceptor);
instance.interceptors.request.use(defaultHeaderInterceptor);
instance.interceptors.request.use(requestInterceptor, requestErrorHandler);
instance.interceptors.response.use(responseInterceptor, responseErrorHandler);

export default instance;
